export default {"src":"/_next/static/media/glow-bottom.2e92759f.svg","height":744,"width":2146,"blurWidth":0,"blurHeight":0};